import { toast } from "react-toastify";
import { ApiCalls, IReceiptData } from "../../../ApiCalls";
import { ReduxUpdater } from "../../../redux/ReduxUpdater";
import PopupMenu, { IPopupMenuAction } from "./PopupMenu";
import { Clipboard, Cog } from "lucide-react";
import { GlobalConstants } from "../../../GlobalConstants";
import { GlobalVariables } from "../../../GlobalVariables";

const AdminMenu = (receipt: IReceiptData) => {
    if (ReduxUpdater.authenticatedUser?.user_role !== GlobalConstants.UserRole.ROOT) {
        return null;
    }

    const menu: IPopupMenuAction[] = [
        {
            extraClass: 'bg-blue-500 text-white',
            title: <>
                ReceiptID: {receipt.id} <Clipboard />
            </>,
            onClick: () => {
                navigator.clipboard.writeText(receipt.id.toString());
                toast.success('ID copied to clipboard');
            },
        },
    ];

    if (receipt.matched_bank_transaction_id !== null) {
        menu.push({
            extraClass: 'bg-blue-500 text-white',
            title: <>
                TransactionID: {receipt.matched_bank_transaction_id} <Clipboard />
            </>,
            onClick: () => {
                if (receipt.matched_bank_transaction_id) {
                    navigator.clipboard.writeText(receipt.matched_bank_transaction_id.toString());
                    toast.success('ID copied to clipboard');
                }
            },
        });
        if (receipt.pan_number) {
            menu.push({
                extraClass: 'bg-blue-500 text-white',
                title: <>
                    Pan#: {receipt.pan_number} <Clipboard />
                </>,
                onClick: () => {
                    navigator.clipboard.writeText(receipt.pan_number);
                    toast.success('Pan Number copied to clipboard');
                },
            });
        }
        menu.push({
            title: 'DIV',
            onClick: () => {}
        });
        menu.push({
            title: 'Unmatch Transaction',
            onClick: () => {
                ApiCalls.unmatchReceipt(receipt.id).then(res => {
                    if (res !== null) {
                        ReduxUpdater.reloadExpensesData();
                        toast.success('Receipt unmatched');
                    } else {
                        toast.error('Failed to change receipt.');
                    }
                }).catch(err => {
                    console.error(err);
                    toast.error('Failed to change receipt.');
                });
            }
        });
    }

    if (receipt.matched_bank_transaction_id === null) {
        if (receipt.pan_number) {
            menu.push({
                extraClass: 'bg-blue-500 text-white',
                title: <>
                    Pan#: {receipt.pan_number} <Clipboard />
                </>,
                onClick: () => {
                    navigator.clipboard.writeText(receipt.pan_number);
                    toast.success('Pan Number copied to clipboard');
                },
            });
        }
        menu.push({
            title: 'DIV',
            onClick: () => {}
        });
        menu.push({
            title: 'Delete !!!',
            extraClass: 'bg-red-600 text-white',
            onClick: () => {
                const saveReceiptChanges = {
                    id: receipt.id,
                    message_id: receipt.message_id,
                    receipt_status: 'trashed',
                } as IReceiptData;
                ApiCalls.updateReceipt(saveReceiptChanges).then(res => {
                    if (res !== null) {
                        ReduxUpdater.reloadExpensesData();
                        toast.success('Receipt Deleted');
                    } else {
                        toast.error('Failed to delete receipt.');
                    }
                }).catch(err => {
                    console.error(err);
                    toast.error('Failed to delete receipt.');
                });
            }
        });
        menu.push({
            title: 'DIV',
            onClick: () => {}
        });
        if (receipt.receipt_type !== null) {
            menu.push({
                title: `Remove ${receipt.receipt_type === 'petty_cash' ? 'Boat Cash' : 'Reimbursement'}`,
                onClick: () => {
                    const saveReceiptChanges = {
                        id: receipt.id,
                        message_id: receipt.message_id,
                        // receipt_status: null,
                        receipt_type: null,
                    } as IReceiptData;
                    ApiCalls.updateReceipt(saveReceiptChanges).then(res => {
                        if (res !== null) {
                            ReduxUpdater.reloadExpensesData();
                            toast.success('Receipt type cleared');
                        } else {
                            toast.error('Failed to change receipt.');
                        }
                    }).catch(err => {
                        console.error(err);
                        toast.error('Failed to change receipt.');
                    });
                }
            });
        }
        if (receipt.receipt_type !== 'petty_cash') {
            menu.push({
                title: 'Convert to Boat Cash',
                onClick: () => {
                    const saveReceiptChanges = {
                        id: receipt.id,
                        message_id: receipt.message_id,
                        receipt_status: null,
                        receipt_type: 'petty_cash',
                    } as IReceiptData;
                    ApiCalls.updateReceipt(saveReceiptChanges).then(res => {
                        if (res !== null) {
                            ReduxUpdater.reloadExpensesData();
                            toast.success('Receipt changed to Boat Cash');
                        } else {
                            toast.error('Failed to change receipt.');
                        }
                    }).catch(err => {
                        console.error(err);
                        toast.error('Failed to change receipt.');
                    });
                }
            });
        }
        if (receipt.receipt_type !== 'reimbursement') {
            menu.push({
                title: 'Convert to Reimbursement',
                onClick: () => {
                    const saveReceiptChanges = {
                        id: receipt.id,
                        message_id: receipt.message_id,
                        receipt_status: null,
                        receipt_type: 'reimbursement',
                    } as IReceiptData;
                    ApiCalls.updateReceipt(saveReceiptChanges).then(res => {
                        if (res !== null) {
                            ReduxUpdater.reloadExpensesData();
                            toast.success('Receipt changed to Reimbursement');
                        } else {
                            toast.error('Failed to change receipt.');
                        }
                    }).catch(err => {
                        console.error(err);
                        toast.error('Failed to change receipt.');
                    });
                }
            });
        }
    }

    if (receipt.receipt_type === 'reimbursement') {
        menu.push({
            title: 'DIV',
            onClick: () => {}
        });
        menu.push({
            title: 'Convert to Reimbursement',
            onClick: () => {
                const saveReceiptChanges = {
                    id: receipt.id,
                    message_id: receipt.message_id,
                    receipt_status: 'confirmed',
                } as IReceiptData;
                ApiCalls.updateReceipt(saveReceiptChanges).then(res => {
                    if (res !== null) {
                        ReduxUpdater.reloadExpensesData();
                        toast.success('Receipt Approved');
                    } else {
                        toast.error('Failed to change receipt.');
                    }
                }).catch(err => {
                    console.error(err);
                    toast.error('Failed to change receipt.');
                });
            }
        });
    }

    menu.push({
        title: 'DIV',
        onClick: () => {}
    });
    menu.push({
        extraClass: 'bg-orange-400 text-white',
        title: 'Receipt History',
        onClick: () => {
            GlobalVariables.dialogConfig.id = receipt.id.toString();
            ReduxUpdater.currentDialog = 'receiptHistory';
        }
    });
    menu.push({
        extraClass: 'bg-green-400 text-white',
        title: 'Upload Receipt',
        onClick: () => {
            ReduxUpdater.currentDialog = 'uploadReceipt';
        }
    });

    return (
        <PopupMenu
            className="absolute top-0 right-0"
            placement="bottom-end"
            menuElements={menu}
        >
            <Cog
                className="clickable"
                height={16}
                width={16}
            />
        </PopupMenu>
    );
}

export default AdminMenu;